const BookIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 20 17" width="20">
      <path d="M14 0a3 3 0 0 0-3 3v10a1 1 0 0 1-2 0V3a3 3 0 0 0-3-3H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.277c.346.595.984 1 1.723 1s1.377-.405 1.723-1H19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z" />
    </svg>
  );
};

export default BookIcon;
